var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconExpandDown = function SvgIconExpandDown(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 9,
    viewBox: "0 0 13 9",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.707 1.293C12.8787 1.46557 12.9816 1.69487 12.9963 1.93788C13.011 2.1809 12.9366 2.42095 12.787 2.613L12.707 2.713L7.70697 7.713C7.53381 7.88331 7.30488 7.98522 7.06244 7.99993C6.82001 8.01463 6.58044 7.94113 6.38797 7.793L6.28797 7.713L1.28797 2.713C1.10062 2.52419 0.995483 2.26898 0.995483 2.003C0.995483 1.73701 1.10062 1.4818 1.28797 1.293C1.46009 1.119 1.69037 1.01462 1.93467 0.999858C2.17898 0.985096 2.42014 1.06099 2.61197 1.213L2.71197 1.293L6.99997 5.582L11.288 1.293C11.4598 1.12035 11.6891 1.01683 11.9322 1.00208C12.1754 0.987337 12.4155 1.06239 12.607 1.213L12.707 1.293Z",
    fill: "#F27C25"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconExpandDown, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_expand_down.f4d7bef6.svg";
export { ForwardRef as ReactComponent };